import React from 'react';
import styled from 'styled-components';
import { BLUE_GREY } from '../../../theme';

const Label = styled.span`
  font-size: 12px;
  color: ${BLUE_GREY};
  line-height: 1.17;
  letter-spacing: -0.1px;
`;

const CheckboxLabel = () => (
  <Label>
    <span>J’ai lu et j’accepte sans réserves les </span>
    <a href="/a-propos/cgv" target="_blank" rel="noreferrer noopener">Conditions générales de vente.</a>
  </Label>
);

export { CheckboxLabel };
